import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import { CustomBlockContent } from './CustomBlockContent';

import GlobalContext from './GlobalContext';
interface ExpendedReportProps {
  open: boolean;
  chapterNumber?: number;
  sections: any;
  activeSection: number;
  changeActiveSection: (i: number) => void;
  mainTitle: string;
  sectionChanged: boolean;
  footer?: boolean;
  openChapter?: boolean;
}

export const ExpendedReport: FC<ExpendedReportProps> = ({
  open,
  chapterNumber,
  sections,
  activeSection,
  changeActiveSection,
  mainTitle,
  sectionChanged,
  footer,
  openChapter,
}) => {
  const SelectedSection = sections[activeSection];
  const [globalState, setGlobalState] = useContext(GlobalContext);
  const {
    title,
    _rawTopText,
    _rawBottomText,
    _rawTextThree,
    _rawTextFour,
    _rawTextFive,
    image,
    imageTwo,
    imageThree,
    imageFour,
    imageFive,
  } = SelectedSection;
  const numberOfSections = sections.length;

  const nextButtonText =
    numberOfSections === activeSection + 1
      ? 'READ THE NEXT CHAPTER'
      : 'READ THE NEXT SECTION';

  return (
    <OpenReport
      id={`chapter${chapterNumber}`}
      showSideMenu={openChapter}
      scrolled={globalState.scrollY < -5500}
    >
      <div
        className={
          open ? 'open-report-container open' : 'open-report-container'
        }
      >
        <div className="three-column" id="three-column">
          {/* <div></div>  If side menu gets fucked I might need to reimplement this empty div for flex positioning*/}
          <div className="side-menu-container">
            <div className="side-menu-wrapper">
              <div className="side-menu">
                <div className="side-menu-title">
                  {!footer && (
                    <div className="chapter-number">
                      Chapter {chapterNumber}{' '}
                    </div>
                  )}
                  <div id={chapterNumber?.toString()} className="chapter-name">
                    {mainTitle}
                  </div>
                </div>

                {sections.map((option: any, i: number) => {
                  //TODO! change active depending on click / scroll

                  return (
                    <div
                      className="list-option"
                      onClick={() => changeActiveSection(i)}
                      key={i}
                    >
                      <div
                        className={`highlight-space ${
                          i === activeSection && 'active'
                        }`}
                      ></div>
                      <div className="list-text">{option.title}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div
            className={`${
              sectionChanged
                ? 'article-container content-change'
                : 'article-container content-change2'
            }`}
          >
            <div className="article-title">{title}</div>
            {_rawTopText && (
              <article>
                <CustomBlockContent blocks={_rawTopText} />
              </article>
            )}

            {image && <img src={image.asset.url} />}
            {_rawBottomText && (
              <article>
                <CustomBlockContent blocks={_rawBottomText} />
              </article>
            )}
            {imageTwo && <img src={imageTwo.asset.url} />}
            {_rawTextThree && (
              <article>
                <CustomBlockContent blocks={_rawTextThree} />
              </article>
            )}
            {imageThree && <img src={imageThree.asset.url} />}
            {_rawTextFour && (
              <article>
                <CustomBlockContent blocks={_rawTextFour} />
              </article>
            )}
            {imageFour && <img src={imageFour.asset.url} />}

            {_rawTextFive && (
              <article>
                <CustomBlockContent blocks={_rawTextFive} />
              </article>
            )}
            {imageFive && <img src={imageFive.asset.url} />}
            {numberOfSections > 1 && (
              <div className="button-container">
                <button onClick={() => changeActiveSection(activeSection + 1)}>
                  {nextButtonText}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </OpenReport>
  );
};

const OpenReport = styled.div<any>`
  .open-report-container {
    padding: 25px;
    max-height: 0;
    transition: max-height 0.25s ease-out;
    padding: 0;
    overflow: hidden;
    padding-top: 70px;
    margin-top: -70px;

    @media (max-width: 1200px) {
      padding-top: 0;
      margin-top: 0;
      }

    .three-column {
      margin: 50px 10%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      display: flex;
      position:relative;
      height: 100000;
      /* max-height: 100vh; */

      @media (max-width: 1200px) {
        padding: 0 25px;
        margin: 25px 0 0 0;
      }

      .side-menu-container {
        width: 400px;
        margin-right: 25px;

        @media (max-width: 1200px) {
          width: 100%;
          margin-right: 0;
          margin-bottom: 140px;
        }
      }

      .side-menu-wrapper {
        position: absolute;
        left: 0;
        margin-top: 80px;
        display: ${(p) => (p.showSideMenu && p.scrolled ? 'block' : 'none')}
      }

      .side-menu-title {
        flex: 1;
        margin-bottom: 25px;
        @media (max-width: 1200px) {
          min-width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 0;
        }

        @media (max-width: 868px) {
          margin-bottom: 0;
        }

        .chapter-number {
          font-style: italic;
          font-family: Agaramond_Italic;
          font-size: 1.2em;
          line-height: 2em;
          @media (max-width: 1200px) {
            margin-right: 10px;
            font-weight: bold;
            font-style: normal;
            font-family: Rift_bold;
          }

          @media (max-width: 868px) {
            font-size: 0.8em;
          }
        }

        .chapter-name {
          font-family: Rift_Bold;
          font-size: 1.2em;
          @media (max-width: 868px) {
            font-size: 0.8em;
          }
        }
      }

      .side-menu {
        width: 400px;
        height: 0px;
        position: fixed;
        top: 120px; 
        margin-right: 25px;
        z-index: 1;

          @media (max-width: 1200px) {
            display: flex;
            flex-wrap: wrap;
            background: #fff;
            height: auto;
            width: auto;
            top: 65px;
            margin: 0 25px 8px 25px;
          }

          @media (max-width: 451px) {
          max-width: 87%;
        }
        }

        @media (max-width: 641px) {
          margin-bottom: 30px;
        }

        .list-option {
          background: var(--lightgrey);
          font-family: NimbusBold;
          font-size: 1em;
          width: 100%;
          margin: 5px 0;
          clear: both;
          cursor: pointer;
          display: flex;

          &:first-child {
            .list-text {
              margin-left: 15px;
            }
          }

          @media (max-width: 1200px) {
            font-size: 0.8em;
            margin-right: 5px;
            min-width: 100px;
            flex: 1;
          }

          @media (max-width: 868px) {
            font-size: 0.5em;
          }

          .highlight-space {
            width: 8px;

            min-width: 8px;
            transition: background-color 250ms ease-in;
          }

          .list-text {
            padding: 10px 10px 10px 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            flex: 1;
          }
        }

        .active {
          background: var(--red);
        }
      }
    }
  }

  .article-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex: 2;
    transition: height 2s;
    max-width: 1024px;
    


    .article-title {
      width: 100%;
      font-family: Rift_Bold;
      font-size: 2em;
      margin-bottom: 25px;
      @media (max-width: 868px) {
        display: none;
      }
    }

    article {
      color: var(----black);
      line-height: 1.2em;
      column-count: 2;
      column-gap: 35px;
      font-size: 1em;
      column-width: 320px;
      margin-bottom: 25px;
      text-align: justify;

      @media (max-width: 868x) {
        column-count: 1;
      }
    }

    img {
      margin-bottom: 25px;
    }
  }

  .open {
    max-height: 10000px;
    transition: max-height 0.25s ease-in;
  }

  .content-change {
    animation: fadeOutIn 1s;
  }

  .content-change2 {
    animation: fadeOutIn2 1s;
  }

  @keyframes fadeOutIn {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }

    80% {
      opacity: 0.8;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOutIn2 {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }

    80% {
      opacity: 0.8;
    }

    100% {
      opacity: 1;
    }
  }


  .button-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 320px;
    button {
      text-transform: uppercase;
      min-width: 100%;
      font-size: 1em;
      color: var(--black);
        &:active {
          background-color: var(--white);
          transform: translateY(4px);
        }
    }
  }
  
`;
